import { type Route, type Store } from 'mobx-router';

export function fillPathTemplate(
    template: string,
    values: Record<string, any>
) {
    return template.replace(/:(\w+)/g, (_, key) => {
        return String(values[key]);
    });
}

export function fillRoute<S extends Store>(
    route: Route<S>,
    pathParams?: Record<string, string>,
    queryParams?: Record<string, string>
) {
    const pathname = fillPathTemplate(route.path, pathParams || {});
    const query = queryParams
        ? new URLSearchParams(queryParams).toString()
        : '';
    const qDelim = query ? '?' : '';
    return `${pathname}${qDelim}${query}`;
}
